import { Component, OnInit } from '@angular/core';

import { GlobalService } from '../services/global.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { ModalService } from '../shared/modal/modal.service';
import { LoadingService } from '../shared/loading/loading.service';
import { Router, ActivatedRoute } from '@angular/router';

import Utils from '../shared/utility';

// import { animateNumber } from '../../assets/tools/util';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  private navCards = [
    { title: 'Add New Advisor', description: 'Create a financial professional profile to run illustrations on this Advisor\'s behalf', icon: 'fa-bar-chart', color: '#a4b7d6', iconColor: '#9578E3', image: '../../../assets/icons/new_advisor.svg', isCreateClient: true, sectionUnlocked: true, actionButton: false},
    { title: 'Add New Client', description: 'Build a client profile (with optional spouse/partner) to run illustrations and reports', icon: 'fa-user-plus', color: '#bdaee0', iconColor: '#3385C5', image: '../../../assets/icons/new_client.svg', isCreateClient: true, sectionUnlocked: true },
    { title: 'Healthcare Express', description: 'Run an express illustration for new clients', icon: 'fa-refresh', color: '#9cbbbb', iconColor: '#2CBFBB', image: '../../../assets/icons/hc_express_white.svg', isCreateClient: true, sectionUnlocked: true },
    { title: 'Create New Illustration', description: 'Run a healthcare, long-term care, or combined illustration for existing client(s)', icon: 'fa-bar-chart', color: '#a7d1ce', iconColor: '#9578E3', image: '../../../assets/icons/illustration.svg', isCreateClient: true, sectionUnlocked: true },
    { title: 'Download Previous Report', description: 'View a client\'s previously-run PDF report', icon: 'fa-file', color: '#91a3c4', iconColor: '#fe4e4e', image: '../../../assets/icons/download_report.svg', isCreateClient: true, sectionUnlocked: true },
    { title: 'Tools & Resources', icon: 'fa-file', color: '#fedede', iconColor: '#fe4e4e', isToolsAndResources: true, isCreateClient: true },
  ]

  public error: any;
  public leads;
  public reports: any;
  public activeAdvisors: any;
  public inactiveAdvisors: any;

  public allClients: any;
  public allReports: any;

  public clientsAdded: number = 0;
  public totalClients: number = 0;

  public reportsCreated: number = 0;

  public recentClients: any = [];
  public recentReports: any = [];

  public clientIncomeAddedMessage: string = "This metric is an approximate combination of two elements effective March 5, 2018: Social Security benefit improvements (estimated by subtracting Earliest total from Alternate total), and income added back due to reduction or elimination of Medicare means testing surcharges (taken from Surcharge Savings output).";
  public healthLTCPreparedMessage: string = "This metric is the approximate total healthcare costs calculated throughout all client reports effective March 5, 2018.";
  public clientsAddedMessage: string = "This metric measures the total households of clients that have been added within this platform.";
  public reportsCreatedMessage: string = "This metric measures the total reports which have been created within this platform that have not been archived.";
  public welcomeHVSPortal: string = "Generate comprehensive illustrations to help clients save for retirement healthcare costs, and prepare for long-term care expenses." ;

  // public recentClients: any;

  public selectedClient: any;

  

  constructor(private globalService: GlobalService, private snackBarService: SnackBarService, private modalService: ModalService, 
    private loadingService: LoadingService, public router: Router) {
      this.globalService.featMeansTesting = JSON.parse(localStorage.getItem('featMeansTesting'));
      this.globalService.featLongTermCare = JSON.parse(localStorage.getItem('featLongTermCare'));
      this.globalService.featSocialSecurity = JSON.parse(localStorage.getItem('featSocialSecurity'));
      this.globalService.featHealthCare = JSON.parse(localStorage.getItem('featHealthCare'));
      this.globalService.featCombinedHealthcareLTC = JSON.parse(localStorage.getItem('featCombinedHealthcareLTC'));
      this.globalService.featHomeOffice = JSON.parse(localStorage.getItem('featHomeOffice'));
      this.globalService.featFunding = JSON.parse(localStorage.getItem('featFunding'));
      this.globalService.featExpressHealthcare = JSON.parse(localStorage.getItem('featExpressHealthcare'));
      this.globalService.featApplications = JSON.parse(localStorage.getItem('featApplications'));
      //this.globalService.featQuickReports = JSON.parse(localStorage.getItem('featQuickReports'));
      this.globalService.featRetirementSuite = JSON.parse(localStorage.getItem('featRetirementSuite'));
      this.globalService.allowedMicrotransactions = JSON.parse(localStorage.getItem('allowedMicrotransactions'));

      //resetting the card array since things need to be removed...
      this.navCards = [];
      if(this.globalService.featHomeOffice){
        this.navCards.push({ sectionUnlocked: true, title: 'Add New Advisor', description: 'Create a financial professional profile to run illustrations on this Advisor\'s behalf', icon: 'fa-bar-chart', color: '#a4b7d6', iconColor: '#9578E3', image: '../../../assets/icons/new_advisor.svg', isCreateClient: true});
      }
      this.navCards.push({ sectionUnlocked: true, title: 'Add New Client', description: 'Build a client profile (with optional spouse/partner) to run illustrations and reports', icon: 'fa-user-plus', color: '#bdaee0', iconColor: '#3385C5', image: '../../../assets/icons/new_client.svg', isCreateClient: true });
      
      if(this.globalService.featExpressHealthcare){
        this.navCards.push({ sectionUnlocked: true, title: 'Healthcare Express', description: 'Run an express illustration for new clients', icon: 'fa-refresh', color: '#9cbbbb', iconColor: '#2CBFBB', image: '../../../assets/icons/hc_express_white.svg', isCreateClient: true });
      } else {
        if(!this.globalService.featHomeOffice){
          this.navCards.push({ sectionUnlocked: true, title: 'Download Previous Report', description: 'View a client\'s previously-run PDF report', icon: 'fa-file', color: '#91a3c4', iconColor: '#fe4e4e', image: '../../../assets/icons/download_report.svg', isCreateClient: true });
        }
      }

      //this.globalService.featRetirementSuite = means the feature was set on login
      //this.globalService.retirementSuiteUnlocked = means they just agreed to the subscription update
      if(this.globalService.featRetirementSuite || this.globalService.retirementSuiteUnlocked){
          this.navCards.push({ sectionUnlocked: true, actionButton: false, title: 'Retirement Suite', description: 'A collective of Advisor facing applications', icon: 'fa-refresh', color: '#9cbbbb', iconColor: '#2CBFBB', image: '../../../assets/icons/hc_express_white.svg', isCreateClient: true });
      } else {
        //bool to check if they are allowed to purchase Retirement Suite here
        if(this.globalService.allowedMicrotransactions){
          //add a purchase card/button
          this.navCards.push({ sectionUnlocked: false, actionButton: true, title: 'Retirement Suite', description: 'A collective of Advisor facing applications', icon: 'fa-refresh', color: '#9cbbbb', iconColor: '#2CBFBB', image: '../../../assets/icons/hc_express_white.svg', isCreateClient: true });
        }
      }

      this.navCards.push({ title: 'Tools & Resources', icon: 'fa-file', color: '#fedede', iconColor: '#fe4e4e', isToolsAndResources: true, isCreateClient: true });          
      this.navCards.push({ sectionUnlocked: true, title: 'Create New Illustration', description: 'Run a healthcare, long-term care, or combined illustration for existing client(s)', icon: 'fa-bar-chart', color: '#a7d1ce', iconColor: '#9578E3', image: '../../../assets/icons/illustration.svg', isCreateClient: true });
      //TODO: uncomment when add back in Healthcare Express
      if(this.globalService.featExpressHealthcare || this.globalService.featHomeOffice){
      //if(this.globalService.featHomeOffice){
        this.navCards.push({ sectionUnlocked: true, title: 'Download Previous Report', description: 'View a client\'s previously-run PDF report', icon: 'fa-file', color: '#91a3c4', iconColor: '#fe4e4e', image: '../../../assets/icons/download_report.svg', isCreateClient: true });
      }
      //{ title: string; description: string; icon: string; color: string; iconColor: string; image: string; isCreateClient: boolean; isToolsAndResources?: undefined; }
      //HACK: added a blank object to trick UI to display with odd number of cards
      this.navCards.push({sectionUnlocked: true, title:'', description: '', icon: '', color: '', iconColor: '', image: '', isCreateClient: false} );
    
      modalService.modal$.subscribe((modal) => {
        if (modal.modalName == 'add-edit-clientClosed') {
          this.recentClients = [];
          // this.getClients();
        }

        console.log('back to home oninit');
      });
  }

  roundAndFormat(num, fixed) {
    if (num === null) { return null; }
    if (num === 0) { return '0'; }
    fixed = (!fixed || fixed < 0) ? 0 : fixed;
    var b = (num).toPrecision(2).split("e"),
        k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3),
        c = k < 1 ? num.toFixed(0 + fixed) : (num / Math.pow(10, k * 3) ).toFixed(1 + fixed),
        d = c < 0 ? c : Math.abs(c),
        e = d + ['', 'K', 'M', 'B', 'T'][k];

    return { shortValue: e.split(/[A-z]/)[0], suffix: e.substring(e.length - 1, e.length) };
  }

  ngOnInit() {
    
  }

  getClients() {
    
    this.globalService.getClientsData()
      .subscribe(
      clients => {
        this.clientsAdded = Utils.formatNumber(clients.length);
        this.totalClients = clients.length;
        this.allClients = clients.map((item) => {
          if (item.c) {
            return {
              name: item.c.FirstName + " " + item.c.LastName,
              email: item.c.Email,
              phone: item.c.Phone || '--',
            }
          } else {
            return {
              name: item.FirstName + " " + item.LastName,
              email: item.Email,
              phone: item.Phone || '--',
            }
          }
          
        });

        this.allClients = this.allClients.reverse();
        
        for (var i = 0; i < 5; i++) {
          if (this.allClients[i]) {
            this.recentClients.push(this.allClients[i]);
          } else {
            this.recentClients.push({
              name: '--',
              email: '--',
              phone: '--',
            });
          }
        }
      },
      error => {
        this.error = <any>error
        
      });
  }

  getReports() {
    this.globalService.getReportsData()
        .subscribe(
            reports => {
              var allReports = [];

              for (var type in reports) {
                reports[type].forEach((report) => {
                  allReports.push(report);
                });
              }


              this.reportsCreated = Utils.formatNumber(allReports.length);

              this.allReports = allReports.map((item) => {
                return {
                  firstName: item.c.FirstName ,
                  lastName: item.c.LastName,
                  clientName: item.c.FirstName + " " + item.c.LastName,
                  reportType: Utils.formatReportTypeID(item.r.ReportTypeID),
                  reportTypeID: item.r.ReportTypeID,
                  date: item.r.Created_Date,
                  reportID: item.r.ReportID,
                  clientID: item.c.ID,
                  advisorID: item.r.AdvisorID,
                  companyCode: item.r.CompanyCode,
                }
              });


              this.allReports = this.allReports.sort((d1, d2) => {
                return Number(new Date(d2.date)) - Number(new Date(d1.date));
              });

              for (var i = 0; i < 5; i++) {
                if (this.allReports[i]) {
                  this.recentReports.push(this.allReports[i]);
                } else {
                  this.recentReports.push({
                    clientName: '--',
                    reportType: '--',
                    date: '--',
                  });
                }
              }
              this.loadingService.isLoading(false);
            },
            error => {
              this.error = <any>error;
              this.loadingService.isLoading(false);
            });
  }

  downloadReport(e, report) {
    
    var reportID = report.reportID;
    var advisorID = report.advisorID;
    var clientID = report.clientID;
    var orgID = report.companyCode;
    var reportTypeID = report.reportTypeID;

    var ReportFields = { reportID, advisorID, clientID, orgID, reportTypeID, token: localStorage.getItem("bearer") };
    this.snackBarService.add(`Downloading your ${Utils.formatReportTypeID(reportTypeID)} report`, 0);
    
    this.loadingService.isLoading(true);

    this.globalService.generateReport(ReportFields, report, ReportFields)
      .subscribe(
      resp => {
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error
        this.loadingService.isLoading(false);
      });
  }

  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() : '--';
  }

  handleCreateClientModal(e) {
    this.modalService.add('add-edit-client', { ID: 0 });
  }

  MarketingMaterial() {
    this.router.navigate(['/marketing-material'])
  }

  InfoCenter() {    
    this.router.navigate(['/info-center'])
  }

  Applications() {
    this.router.navigate(['/applications'])
  }

  resetDashboard(data){
    if(data == true){
      const foundItem = this.navCards.find(item => item.title === 'Retirement Suite');
      foundItem.sectionUnlocked = true;
      foundItem.actionButton = false;
    }
  }
}
